import { addDays, endOfMonth, startOfMonth, subDays } from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'

import { CALENDAR_RANGE_PADDING_DAYS } from '@/helpers/constants'

// Range the management calendar loads for the month containing `date`: the whole month in the
// building's timezone, padded so the leading/trailing days of the month grid are covered too.
// Every path that sets the calendar dates must use this, otherwise the same month ends up with
// different ranges (and query keys) depending on how the user got there.
export const getCalendarMonthRange = (date: Date | number, timezone: string) => ({
  start: fromZonedTime(
    subDays(startOfMonth(date), CALENDAR_RANGE_PADDING_DAYS),
    timezone,
  ).getTime(),
  end: fromZonedTime(addDays(endOfMonth(date), CALENDAR_RANGE_PADDING_DAYS), timezone).getTime(),
})

const START_OF_DAY_MINUTES = 0
const END_OF_DAY_MINUTES = 24 * 60

// Full day = starts at midnight and ends at 23:59 or 24:00. Missing times mean the
// start/end of the day, which is how the time-blocks table treats them.
export const isFullDayTimeBlock = (
  timeBlock?: { startTime?: number | null; endTime?: number | null } | null,
): boolean => {
  if (!timeBlock) return false

  const start = timeBlock.startTime ?? START_OF_DAY_MINUTES
  const end = timeBlock.endTime ?? END_OF_DAY_MINUTES

  return start === START_OF_DAY_MINUTES && end >= END_OF_DAY_MINUTES - 1 // 1439 (23:59) or 1440
}
